import EventCard from './EventCard';

interface Event {
  title: string;
  description: string;
  pastEvents: string[];
  svg: JSX.Element;
}

const events: Event[] = [
  {
    title: 'Food & Beverage',
    description:
      'Join us at local restaurants learning to create their staple dishes. Not into cooking? Come meet new people at our cocktail hours instead.',
    pastEvents: [
      'Bubble Tea Workshop',
      'Learn to Cook Musubi',
      'Soju Cocktail Hour',
    ],
    svg: (
      <svg
        className="show"
        width="50"
        height="50"
        viewBox="-1 -1 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.15564 19.5413L3.64952 19.4633L3.64952 19.4633L3.15564 19.5413ZM12.8444 19.5413L13.3382 19.6193L13.3382 19.6193L12.8444 19.5413ZM6 5.83333C6.27614 5.83333 6.5 5.60948 6.5 5.33333C6.5 5.05719 6.27614 4.83333 6 4.83333V5.83333ZM10 4.83333C9.72386 4.83333 9.5 5.05719 9.5 5.33333C9.5 5.60948 9.72386 5.83333 10 5.83333V4.83333ZM0.839452 8.07798L2.66176 19.6193L3.64952 19.4633L1.82721 7.92202L0.839452 8.07798ZM4.47266 21.1667H11.5273V20.1667H4.47266V21.1667ZM13.3382 19.6193L15.1605 8.07798L14.1728 7.92202L12.3505 19.4633L13.3382 19.6193ZM11.5273 21.1667C12.4295 21.1667 13.1975 20.5104 13.3382 19.6193L12.3505 19.4633C12.2865 19.8683 11.9374 20.1667 11.5273 20.1667V21.1667ZM2.66176 19.6193C2.80246 20.5104 3.57052 21.1667 4.47266 21.1667V20.1667C4.0626 20.1667 3.71348 19.8683 3.64952 19.4633L2.66176 19.6193ZM1.83333 6C1.83333 4.69317 2.50014 3.31823 3.62805 2.26008C4.75147 1.20614 6.29882 0.5 8 0.5V-0.5C6.01928 -0.5 4.23329 0.321097 2.94386 1.53078C1.65892 2.73625 0.833333 4.36131 0.833333 6H1.83333ZM8 0.5C9.70118 0.5 11.2485 1.20614 12.3719 2.26008C13.4999 3.31823 14.1667 4.69317 14.1667 6H15.1667C15.1667 4.36131 14.3411 2.73625 13.0561 1.53078C11.7667 0.321097 9.98072 -0.5 8 -0.5V0.5ZM14.6667 7.5H1.33333V8.5H14.6667V7.5ZM1.33333 7.5C0.873096 7.5 0.5 7.1269 0.5 6.66667H-0.5C-0.5 7.67919 0.320811 8.5 1.33333 8.5V7.5ZM15.5 6.66667C15.5 7.1269 15.1269 7.5 14.6667 7.5V8.5C15.6792 8.5 16.5 7.67919 16.5 6.66667H15.5ZM14.6667 5.83333C15.1269 5.83333 15.5 6.20643 15.5 6.66667H16.5C16.5 5.65414 15.6792 4.83333 14.6667 4.83333V5.83333ZM1.33333 4.83333C0.320811 4.83333 -0.5 5.65414 -0.5 6.66667H0.5C0.5 6.20643 0.873096 5.83333 1.33333 5.83333V4.83333ZM1.33333 5.83333H6V4.83333H1.33333V5.83333ZM10 5.83333H14.6667V4.83333H10V5.83333Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    title: 'Art & Culture',
    description:
      'Learn to create using different mediums with our featured local Asian artists.',
    pastEvents: [
      'Paint & Sip Night',
      'Create a Pokemon Ornament',
      'Photowalk Session',
    ],
    svg: (
      <svg
        width="50"
        height="50"
        viewBox="-1 -1 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6208 0.178299C21.5659 -0.180063 22.3792 0.911138 25.0405 3.17871C27.583 5.34497 26.0811 10.3203 25.0405 11.5C24 12.6797 21.2416 13.7227 17.6208 15.6113C14 17.5 12.5 26 7 26.1113C1.5 26.2227 0 25.1797 0 20.6797C0 16.1797 2.5 14 5 12.6797C7.5 11.3594 9.31917 7.05671 10.9267 5.1783C12.9716 2.78878 13.9262 0.513909 17.6208 0.178299Z"
          fill="#D25D19"
        />
      </svg>
    ),
  },
  {
    title: 'Active',
    description:
      'Come to our night markets and eat great food or join our local instructors as they teach you the latest dance moves.',
    pastEvents: ['Kpop Dance Lessons', 'Night Market (Coming soon to YYC.)'],
    svg: (
      <svg
        width="50"
        height="50"
        viewBox="-1 -1 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4379 20.4768L8.52525 18.6186M8.52525 18.6186C8.52525 18.6186 7.10438 18.1677 6.17529 19.1241C5.40382 19.9181 5.612 21.0231 5.70485 21.3752C5.72464 21.4502 5.76696 21.5158 5.82264 21.5699L10.0191 25.6469C10.034 25.6613 10.0471 25.6729 10.064 25.6849C10.4038 25.9276 14.5468 28.7252 19.4549 24.5897C24.293 20.5131 22.4066 16.5338 22.1813 16.1029C22.1671 16.0758 22.1505 16.0527 22.1307 16.0294L19.557 13.0039M8.52525 18.6186C8.52525 18.6186 7.5553 16.7468 8.4844 15.7905C9.41349 14.8342 10.8344 15.2851 10.8344 15.2851M17.9387 17.5398L13.1435 11.9516M10.8344 15.2851L13.2252 17.6078M10.8344 15.2851C10.8344 15.2851 9.39987 13.8915 10.7935 12.457C12.1871 11.0225 13.1435 11.9516 13.1435 11.9516M13.1435 11.9516L10.2826 8.24971C10.2681 8.23099 10.2532 8.21422 10.2369 8.19704C10.0552 8.00499 8.93455 6.71661 10.22 5.39346C11.5245 4.05076 12.8647 5.18582 13.0309 5.33659C13.0426 5.34723 13.0533 5.35864 13.0635 5.3707L16.3133 9.19084M16.3133 9.19084L17.2854 5.80356C17.2932 5.77635 17.3028 5.7509 17.3159 5.72581C17.4527 5.46341 18.3306 3.90109 19.6335 4.31456C20.9011 4.71685 21.0595 6.26084 21.0789 6.58926C21.0814 6.63091 21.0767 6.67143 21.067 6.712L19.557 13.0039M16.3133 9.19084L19.557 13.0039"
          stroke="black"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

const EventSection: React.FC = () => {
  return (
    <section className="flex justify-center flex-wrap gap-8 w-full">
      <h3 className="show font-aleo">What type of events do we host?</h3>
      <div className="flex flex-row px-[12vw] justify-center flex-wrap gap-8">
        {events.map((event, index) => (
          <EventCard
            key={index}
            title={event.title}
            description={event.description}
            pastEvents={event.pastEvents}
            svg={event.svg}
          />
        ))}
      </div>
    </section>
  );
};

export default EventSection;
